export enum FeatureFlagScopeType {
    System = 1,
    Organization = 2,
    Group = 3,
    UserRole = 4,
}
